import React, { useEffect} from "react";
import useAuth from "../context/AuthContext";
import { createScriptElement, createUserFromPropo } from "../utils/utils";
import useAppState from "../context/AppContext";
import { isMGPAffiliation } from "../utils/permissionUtils";

interface IVisitorInfo {
  country_name?: string;
  city?: string;
  ip?: string;
  org?: string;
}
const delayMs = parseInt(process.env.REACT_APP_RIZCHAT_SHOWN_AFTER || '0', 10);

const getDeviceInfo = () => {
  const userAgent = navigator.userAgent;
  const platform = navigator.platform;

  const device = /Mobile|Android|iPhone|iPad/.test(userAgent) ? 'MOBILE' : 'DESKTOP';
  const os = /Android/.test(userAgent) ? 'ANDROID'
    : /iPhone|iPad|iPod/.test(userAgent) ? 'IOS'
    : /Win/.test(platform) ? 'WINDOWS'
    : /Mac/.test(platform) ? 'MAC'
    : /Linux/.test(platform) ? 'LINUX'
    : 'UNKNOWN';

  return { device, os };
};

export const useAddRizChat = () => {
  const {
      state: { proposition, isRetired},
    } = useAppState();

  const user = createUserFromPropo(proposition);

  useEffect(() => {
    console.log('useAddRizChat::user', user, window.RizChat);
    console.log("chat will be shown in ", delayMs)
    const timer = setTimeout(() => {

    // 1. Always load RizChat
    if (!window.RizChat) {
      const rizChatScript = `
        (function(w, d, s, u) {
          w.RizChat = function(c) { w.RizChat._.push(c) }; w.RizChat._ = []; w.RizChat.url = u;
          let h = d.getElementsByTagName(s)[0], j = d.createElement(s);
          j.async = true; j.src = '${process.env.REACT_APP_RIZCHAT_LIVECHAT_URL}/rizchat-livechat.min.js?_=201903270000';
          h.parentNode.insertBefore(j, h);
        })(window, document, 'script', '${process.env.REACT_APP_RIZCHAT_LIVECHAT_URL}');
      `;

      const scriptElement = createScriptElement(rizChatScript);
      document.head.appendChild(scriptElement);
    }

    if (window.rizChatLoading) {
      clearInterval(window.rizChatLoading);
    }

    window.rizChatLoading = setInterval(() => {
      // 2. Wait for RizChat to load
      if (window.RizChat?.livechat?.setGuestMetadata) {
        const role =  isRetired ?  'retraite' : isMGPAffiliation(user?.company) ?  'affiliationMGP' : 'affiliation';

        // 3. Show widget (with metdata) only if user is adherent, otherwise close current chat (if exists) and hide it
        if ( proposition && role === 'affiliation') {
          console.log('role', role);
          (async () => {
            const { device, os } = getDeviceInfo();
            const browserLanguage = navigator.language || 'fr-FR';

            const visitorInfo: IVisitorInfo = await fetch(process.env.REACT_APP_IPAPI_URL || 'https://ipapi.co/json/')
              .then(res => res.json())
              .then(data => {
                return {
                  country_name: data.country_name,
                  city: data.city,
                  ip: data.ip,
                  org: data.org
                };
              })
              .catch(err => {
                console.error('Error fetching location data:', err);
                return {
                  country_name: 'France',
                  city: 'Unknown',
                  ip: '',
                  org: 'Unknown'
                };
              });

            const  department = process.env.REACT_APP_RIZCHAT_DEPARTMENT_AFFILIATION;
            const metadata = {
              "cxlvhlp_visitorcountry": visitorInfo.country_name || "France",
              "cxlvhlp_visitorcity": visitorInfo.city || "Unknown",
              "cxlvhlp_visitorlanguage": browserLanguage,
              "cxlvhlp_visitordevice": device,
              "cxlvhlp_visitoros": os,
              "cxlvhlp_isp": visitorInfo.org || "Unknown",
              "cxlvhlp_visitoripaddress": visitorInfo.ip || "",
              "cxlvhlp_visitorfirstname": user.firstName || "",
              "cxlvhlp_visitoremail": "",
              "cxlvhlp_waittimeinmillis": "84718",
              "email": `${user.email}`,
              "name": `${user.firstName} ${user.lastName}`,
              "tenant_user_id": user.contactId,
              "department_id": department
            };

            console.log('metadata', metadata);
            window.RizChat?.livechat?.setGuestMetadata(metadata);
            console.log('set metadata: ',metadata);

            // Capture metadata & set it again once logged out
            if (window.RizChat?.livechat?.onChatEnded) {
              window.RizChat?.livechat?.onChatEnded(() => {
                window.RizChat?.livechat?.setGuestMetadata(metadata);
                console.log("set metadata again after chat ended: ",metadata);
              });
            }
            clearInterval(window.rizChatLoading);
          })();
        } else {
          console.log('useAddRizChat hideWidget');
          window.RizChat?.livechat?.hideWidget();
        }
      }
    }, 1000);
    }, delayMs);
    return () => clearTimeout(timer);

  }, [proposition?.contact?.contactId]);
};